export const START_LOADING = 'accionStartLoading';
export const STOP_LOADING = 'accionStopLoading';

export const startLoading = () => ({
    type: START_LOADING
});

export const stopLoading = () => ({
    type: STOP_LOADING,
});